const TYPE_COLORS = {
  string: { light: { bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" }, dark: { bg: "#1E3A8A22", text: "#93C5FD", border: "#3B82F640" } },
  int: { light: { bg: "#F5F3FF", text: "#6D28D9", border: "#DDD6FE" }, dark: { bg: "#5B21B622", text: "#C4B5FD", border: "#8B5CF640" } },
  file: { light: { bg: "#FFFBEB", text: "#B45309", border: "#FDE68A" }, dark: { bg: "#78350F22", text: "#FCD34D", border: "#F59E0B40" } },
};

export function getColumnTypeColors(type, dark) {
  return TYPE_COLORS[type] ?? TYPE_COLORS.string;
}

export function getColumnTypePalette(type, dark) {
  const entry = getColumnTypeColors(type, dark);
  return dark ? entry.dark : entry.light;
}
